export const barcode = (data, options = {}) => ({
  cmd: 'barcode',
  data,
  ...options,
});

export const cut = () => ({
  cmd: 'cut',
});

export const feed = (options = {}) => ({
  cmd: 'feed',
  ...options,
});

export const image = (url, options = {}) => ({
  cmd: 'image',
  url,
  ...options,
});

export const line = () => ({
  cmd: 'line',
});

export const peripheral = () => ({
  cmd: 'peripheral',
  channel: 1,
  time: 200,
});

export const table = (columns = []) => ({
  cmd: 'table',
  columns,
});

export const text = (data, options = {}) => ({
  cmd: 'text',
  data,
  ...options,
});

export default { barcode, cut, feed, image, line, peripheral, table, text };
